import React from "react";

class Shortcuts extends React.Component {

    constructor (props) {
        super(props);

        // binding
        this.handleShowSearchWindow = this.handleShowSearchWindow.bind(this);
        this.shortcutClick = this.shortcutClick.bind(this); 
    }

  
    handleShowSearchWindow(event, show) {

        event.stopPropagation()
        
        this.props.openSearchClicked(show);
        const event_name = 'ShortcutAdvancedSearch';
        
        // add GTM custom event
        if (window['google_tag_manager']) {
            console.log('GTM event: ' + event_name)

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: event_name,
                eventTimeout: 2000,
                pageUrl: window.location,
                pageTitle : window.title,
            });
        }
    }

    shortcutClick(event, event_name, url) {

        event.stopPropagation()

        // add GTM custom event
        if (window['google_tag_manager']) {
            console.log('GTM event: ' + event_name)

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: event_name,
                eventTimeout: 2000,
                target_url: url,
                pageUrl: window.location,
                pageTitle : window.title,
                eventCallback: function() {
                    window.location = url;
                }
            });
        } else {
            window.location.href=url;
        }

    }

    render() {
        if (!this.props.hidden)
            return(
                <>
                <div className={this.props?.active||this.props?.searchResults?'shortcuts-block mobile':'shortcuts-block'}>
                    {this.props?.hideHeader || this.props?.active?(
                        <></>
                    ):(
                        <h2>איזה חופשה מתאימה לכם?</h2>
                    )}
                    <div className="wrapper">
                        <div className={this.props?.active=='best'?'shortcut selected':'shortcut'} >
                            <a href="/best-deals/" title="הדילים הכי זולים" onClick={e=> {this.shortcutClick(e, 'ShortcutBestDeals', '/best-deals/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/tag@3x.png" alt="דילים זולים" />
                                </div>
                                <div className="label">
                                    הדילים הכי זולים
                                </div>
                            </a>
                        </div>

                        <div className={this.props?.active=='last-minute'?'shortcut selected':'shortcut'}>
                            <a href="/last-minute/" title="דילים ברגע האחרון"  onClick={e=> {this.shortcutClick(e, 'ShortcutLastMinute', '/last-minute/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/clock@3x.png" alt="דילים ברגע האחרון" />
                                </div>
                                <div className="label">
                                    דילים ברגע האחרון
                                </div>
                            </a>
                        </div>

                        <div className={this.props?.active=='weekends'?'shortcut selected':'shortcut'} >
                            <a href="/weekends/" title="דילים בסופי שבוע" onClick={e=> {this.shortcutClick(e, 'ShortcutWeekendDeals', '/weekends/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/star@3x.png" alt="דילים בסופי שבוע" />
                                </div>
                                <div className="label">
                                    דילים בסופי-שבוע
                                </div>
                            </a>
                        </div>

                        <div className={this.props?.active=='5stars'?'shortcut selected':'shortcut'} >
                            <a href="/5-stars/" title="חופשות יוקרה" onClick={e=> {this.shortcutClick(e, 'Shortcut5Stars', '/5-stars/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/diamond@3x.png" alt="חופשות יוקרה" />
                                </div>
                                <div className="label">
                                    חופשות במלונות יוקרה
                                </div>
                            </a>
                        </div>

{/*
                        <div className={this.props?.active=='summer-vacation'?'shortcut summer-vacation selected':'shortcut summer-vacation'} >
                            <a href="/summer-vacation/" title="דילים בחופש הגדול" onClick={e=> {this.shortcutClick(e, 'ShortcutSummerVacation','/summer-vacation/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/beach@3x.png" alt="דילים בחופש הגדול" />
                                </div>
                                <div className="label">
                                    דילים בחופש-הגדול 
                                </div>
                            </a>
                        </div>
 */}
                           
                        {/* 
                        <div className={this.props?.active=='summer-family'?'shortcut summer-family selected':'shortcut summer-family new'} >
                            <a href="/summer-family/" title="דילים  למשפחות" onClick={e=> {this.shortcutClick(e, 'ShortcutSummerFamily', '/summer-family/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/2x/family@2x.png" alt="דילים למשפחות" />
                                </div>
                                <div className="label">
                                    דילים למשפחות בקיץ
                                </div>
                            </a>
                        </div>
                        */}


                        <div className={this.props?.active=='all-inclusive'?'shortcut all-inclusive selected':'shortcut all-inclusive new'} >
                            <a href="/all-inclusive-deals/" title="דילים הכל כלול" onClick={e=> {this.shortcutClick('ShortcutAllInclusive', '/all-inclusive-deals/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/2x/pineapple@2x.png" alt="דילים הכל כלול" />
                                </div>
                                <div className="label">
                                    דילים במלונות הכל-כלול
                                </div>
                            </a>
                        </div>

                        <div className={this.props?.active=='passover-vacation'?'shortcut passover selected':'shortcut passover new'} >
                            <a href="/passover-vacation-deals/" title="דילים בפסח למשפחות" onClick={e=> {this.shortcutClick(e, 'ShortcutPassover', '/passover-vacation-deals/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/2x/passover@2x.png" alt="דילים בפסח למשפחות" />
                                </div>
                                <div className="label">
                                    דילים בחופש פסח
                                </div>
                            </a>
                        </div>
                        <div className={this.props?.active=='summer'?'shortcut summer selected':'shortcut summer'} >
                            <a href="/summer-deals/" title="דילים בקיץ 2024" onClick={e=> {this.shortcutClick(e, 'ShortcutSummer','/summer-deals/')}}>
                                <img className='new' src="/images/icons/new2.png"></img>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/beach@3x.png" alt="דילים בקיץ 2024" />
                                </div>
                                <div className="label">
                                    דילים בקיץ 2024
                                </div>
                            </a>
                        </div>



 {/*                    <div className={this.props?.active=='xmas'?'shortcut xmas selected':'shortcut '} >
                            <a href="/xmas-deals/" title="דילים בכריסמס " onClick={e=> {this.shortcutClick(e, 'ShortcutXmas','/xmas-deals/')}}>
                                <img className='new' src="/images/icons/new2.png"></img>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/xmas@3x.png" alt="דילים בקריסמס" />
                                </div>
                                <div className="label">
                                    דילים בתקופת הכריסמס
                                </div>
                            </a>
                        </div>

                        <div className={this.props?.active=='sukkot-vacation'?'shortcut sukkot selected':'shortcut sukkot new'} >
                            <a href="/sukkot-vacation-deals/" title="דילים בחופש סוכות" onClick={e=> {this.shortcutClick('ShortcutSukkot', '/sukkot-vacation-deals/')}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/2x/sukkot@2x.png" alt="דילים בחופש סוכות" />
                                </div>
                                <div className="label">
                                    דילים בחופש סוכות
                                </div>
                            </a>
                        </div>

*/}
                            
                        <div className={this.props?.active=='search'?'shortcut search selected':'shortcut search'} >
                            <span href="#deals" title="חיפוש מותאם אישית" onClick={e=>{this.handleShowSearchWindow(e, true)}}>
                                <div className="image">
                                    <img className="circle" src="/images/icons/shortcuts/3x/calendar@3x.png" alt="חיפוש מותאם אישית" />
                                </div>
                                <div className="label">
                                    חיפוש מותאם-אישית
                                </div>
                            </span>
                        </div>
                        
                    </div>
                </div>
            </>
            ) 
            else
                return (<></>);
    }
}

export default Shortcuts